export const normalizePhone = (phone?: string | null) =>
	(phone ?? "").replace(/\D/g, "");
